import React, { useState } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { langConversionHelper } from "@/_helpers";
import PropTypes from "prop-types";
import Cookies from "universal-cookie";

import { userChangeLanguage } from "../_redux/actions/languageActions";
import { loadDocuments } from "../_redux/actions/documentActions";

import { withStyles } from "@mui/styles";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Tooltip from "@mui/material/Tooltip";

import LanguageIcon from "@mui/icons-material/Language";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

const CustomIconButton = withStyles((theme) => ({
  root: {
    height: 59,
    width: 59,
    [theme.breakpoints.down("md")]: {
      width: 47,
    },
  },
}))(IconButton);

const lngs = langConversionHelper.languageList();

const LanguageSelector = ({ userChangeLanguage, loadDocuments }) => {
  const cookies = new Cookies();
  const user = cookies.get("lifesaferUser");
  const { t, i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleUserCookieUpdate = (newLangID) => {
    if (user !== undefined) {
      let updatedUser = {
        ...user,
        languageID: newLangID,
      };
      cookies.set("lifesaferUser", JSON.stringify(updatedUser), {
        path: "/",
        sameSite: "strict",
      });
      loadDocuments(user.clientID, user.userId, newLangID);
    }
  };
  return (
    <Grid container direction="row" justifyContent="center" alignItems="center">
      <Grid item>
        <Tooltip title={t("navigation.language")}>
          <CustomIconButton
            aria-controls="simple-menu"
            aria-haspopup="true"
            onClick={handleClick}
          >
            <ArrowDropDownIcon fontSize="small" style={{ marginLeft: -6 }} />
            <LanguageIcon
              style={{ width: 32, height: 32, marginLeft: -6 }}
              color="primary"
            />
          </CustomIconButton>
        </Tooltip>
        <Menu
          id="simple-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleClose}
        >
          {lngs.map((lng) => (
            <MenuItem
              key={lng.langAbbrev}
              style={{
                fontWeight: i18n.language === lng.langAbbrev ? 600 : "normal",
              }}
              onClick={() => {
                i18n.changeLanguage(lng.langAbbrev);
                userChangeLanguage([lng.langAbbrev]);
                handleUserCookieUpdate(lng.languageID);
                setAnchorEl(null);
              }}
            >
              {lng.nativeName}
            </MenuItem>
          ))}
        </Menu>
      </Grid>
    </Grid>
  );
};

LanguageSelector.propTypes = {
  userChangeLanguage: PropTypes.func.isRequired,
  loadDocuments: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
  return {
    selectedLanguage: state.selectedLanguage,
  };
}

export default connect(mapStateToProps, { userChangeLanguage, loadDocuments })(
  LanguageSelector
);
